var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Translate } from "../../I18N";
import React, { useCallback, useRef, useState } from 'react';
import { Icon } from "../../UI";

import debounce from "../../utils/debounce";
import { MemberListItemInfo } from "./MemberListItemInfo";







export const UserGroupsLookupField = ({
  onChange,
  onSelect,
  options
}) => {
  const [selected, setSelected] = useState(null);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedOnChange = useCallback(debounce(onChange, 500), [onChange]);

  const onChangeHandler = (event) => {
    setShow(true);
    setSearchTerm(event.target.value);
    debouncedOnChange(event.target.value);
  };

  const getOnSelectHandler = (selection) => () => {
    onSelect(selection);
    setShow(false);
  };

  const onKeyPressHandler = (event) => {
    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        if (!selected) {
          setSelected(options.length - 1);
        } else {
          setSelected((selected - 1) % options.length);
        }

        break;
      case 'ArrowDown':
        event.preventDefault();
        if (selected === null) {
          setSelected(0);
        } else {
          setSelected((selected + 1) % options.length);
        }

        break;
      case 'Enter':
        event.preventDefault();
        if (selected !== null) {
          onSelect(options[selected]);
          setShow(false);
        }
        break;
      case 'Escape':
        event.preventDefault();
        setShow(false);
        break;
      default:
        break;}

  };

  const optionsListRef = useRef(null);

  return /*#__PURE__*/(
    _jsx("div", { className: "userGroupsLookupField" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      placeholder: "Add people or groups",
      onChange: onChangeHandler,
      onKeyDown: onKeyPressHandler,
      onBlur: (e) => {
        if (e.relatedTarget !== optionsListRef.current) {
          setShow(false);
        }
      },
      onFocus: () => {
        setShow(true);
      },
      value: searchTerm }),

    show && options.length ? /*#__PURE__*/
    React.createElement("ul", { tabIndex: -1, role: "listbox", ref: optionsListRef },
    options.map((result, index) => /*#__PURE__*/
    _jsx("li", {

      role: "option",
      "aria-selected": index === selected,
      onClick: getOnSelectHandler(result),
      className: index === selected ? 'selected' : '' }, `${result.type}-${result.refId}`, /*#__PURE__*/

    _jsx(MemberListItemInfo, { value: result }), /*#__PURE__*/
    _jsx("div", { className: "press-enter-note" }, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Press enter to add")), /*#__PURE__*/

    _jsx(Icon, { icon: "level-down-alt", transform: { rotate: 90 } }))))) :




    null));


};